'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextCycleMessage = exports.SchedulesAlert = exports.SchedulesLoadingMessage = exports.SchedulesErrorMessage = exports.NoSchedulesOfClassTodayMessage = exports.NoSchedulesSelectedDateMessage = exports.NoSchedulesTodayMessage = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoSchedulesTodayMessage = exports.NoSchedulesTodayMessage = function NoSchedulesTodayMessage() {
  return _react2.default.createElement(
    'div',
    { className: 'schedule__message' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.no-results',
      defaultMessage: 'There are no upcoming classes on this day'
    })
  );
};

var NoSchedulesSelectedDateMessage = exports.NoSchedulesSelectedDateMessage = function NoSchedulesSelectedDateMessage(_ref) {
  var date = _ref.date;
  return _react2.default.createElement(
    'div',
    { className: 'schedule__header-message' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.noClasses',
      defaultMessage: 'There are no classes {date}.',
      values: { date: date }
    })
  );
};

NoSchedulesSelectedDateMessage.propTypes = {
  date: _propTypes2.default.node.isRequired
};

var NoSchedulesOfClassTodayMessage = exports.NoSchedulesOfClassTodayMessage = function NoSchedulesOfClassTodayMessage(_ref2) {
  var nameOfClass = _ref2.nameOfClass,
      venueUrl = _ref2.venueUrl;
  return _react2.default.createElement(
    'div',
    { className: 'schedule__message' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.no-results-for-class',
      defaultMessage: 'There are no upcoming \u201C{nameOfClass}\u201D classes on this day.',
      values: { nameOfClass: nameOfClass }
    }),
    _react2.default.createElement(
      'p',
      { className: 'mt' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.no-results-for-class.line-2',
        defaultMessage: '{link} to see other classes.',
        values: {
          link: _react2.default.createElement(
            _reactRouter.Link,
            { to: venueUrl },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'schedule.no-results-for-class.link',
              defaultMessage: 'View the full studio schedule'
            })
          )
        }
      })
    )
  );
};

NoSchedulesOfClassTodayMessage.propTypes = {
  nameOfClass: _propTypes2.default.string.isRequired,
  venueUrl: _propTypes2.default.string.isRequired
};

var SchedulesErrorMessage = exports.SchedulesErrorMessage = function SchedulesErrorMessage(_ref3) {
  var onClick = _ref3.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'schedule__message' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.error-loading',
      defaultMessage: 'There was an error loading the schedule.'
    }),
    _react2.default.createElement(
      'p',
      { className: 'mt' },
      _react2.default.createElement(
        'button',
        { onClick: onClick, className: 'bt bt--tertiary bt--width-md' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'schedule.error-loading.retry',
          defaultMessage: 'Retry'
        })
      )
    )
  );
};

SchedulesErrorMessage.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

var SchedulesLoadingMessage = exports.SchedulesLoadingMessage = function SchedulesLoadingMessage() {
  return _react2.default.createElement(
    'div',
    { className: 'schedule__message' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.loading',
      defaultMessage: 'Loading schedule'
    })
  );
};

var SchedulesAlert = exports.SchedulesAlert = function SchedulesAlert(_ref4) {
  var children = _ref4.children;
  return _react2.default.createElement(
    'div',
    { className: 'schedule__alert-message' },
    children
  );
};

SchedulesAlert.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node]).isRequired
};

var NextCycleMessage = exports.NextCycleMessage = function NextCycleMessage() {
  return _react2.default.createElement(
    SchedulesAlert,
    null,
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.nextCycle',
      defaultMessage: 'You are viewing classes in your next cycle'
    })
  );
};